// Cookie utility functions for managing cookie preferences

const COOKIE_CONSENT_KEY = 'cookie_consent';
const COOKIE_PREFERENCES_KEY = 'cookie_preferences';

export const getCookieConsent = () => {
  try {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    return consent ? JSON.parse(consent) : null;
  } catch (error) {
    return null;
  }
};

export const setCookieConsent = (consent) => {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      ...consent,
      timestamp: new Date().toISOString()
    }));
  } catch (error) {
    console.error('Error saving cookie consent:', error);
  }
};

export const getCookiePreferences = () => {
  try {
    const preferences = localStorage.getItem(COOKIE_PREFERENCES_KEY);
    return preferences ? JSON.parse(preferences) : {
      necessary: true, // Always true, cannot be disabled
      analytics: false,
      marketing: false,
      functional: false
    };
  } catch (error) {
    return {
      necessary: true,
      analytics: false,
      marketing: false,
      functional: false
    };
  }
};

export const setCookiePreferences = (preferences) => {
  try {
    localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify({
      ...preferences,
      timestamp: new Date().toISOString()
    }));
  } catch (error) {
    console.error('Error saving cookie preferences:', error);
  }
};

export const hasConsented = () => {
  const consent = getCookieConsent();
  return consent !== null;
};

export const acceptAllCookies = () => {
  const preferences = {
    necessary: true,
    analytics: true,
    marketing: true,
    functional: true
  };
  setCookiePreferences(preferences);
  setCookieConsent({
    accepted: true,
    method: 'accept_all'
  });
};

export const rejectAllCookies = () => {
  const preferences = {
    necessary: true,
    analytics: false,
    marketing: false,
    functional: false
  };
  setCookiePreferences(preferences);
  setCookieConsent({
    accepted: true,
    method: 'reject_all'
  });
};

export const saveCustomPreferences = (preferences) => {
  setCookiePreferences({
    necessary: true, // Always true
    analytics: preferences.analytics || false,
    marketing: preferences.marketing || false,
    functional: preferences.functional || false
  });
  setCookieConsent({
    accepted: true,
    method: 'custom'
  });
};

